import React from "react";
import formItemLayout from "../../../common/form/formItemLayout";
import FormItemDictSelect from "../../../common/form/select/FormItemDictSelect";
import AisinoFieldset from "../../../baseComponent/fieldset/AisinoFieldset";
import FormItemInput from "../../../common/form/input/FormItemInput";
import {getLanguage} from "../../../source/js/common";
import {CountryCode, IDType, IndividualIdType, StateCode} from "../../../dictionary";
import FormItemUrlSelect from "../../../common/form/select/formItemUrlSelect";
import {postSync} from "../../../common/utils/http";
import {aisinoConfirmModal, aisinoInfoModal} from "../../../common/modal/AisinoModalMethod";
import FormItemSearch from "../../../common/form/input/FormItemSearch";
import {checkContactNum, isEmpty} from "../../../common/utils/StringUtils";
import {ScanOutlined} from "@ant-design/icons";

const invoiceLan = require('../../../constant/js/formItemNameLabel/'+getLanguage()+'/invoice.js');
const commonLan = require('../../../constant/js/formItemNameLabel/'+getLanguage()+'/common.js');

class NonIndividualBuyerInfo extends React.Component {

    constructor(props){
        super(props)
        this.state={
            changeBuyerTin: null,
            stateCodeDisabled:false,
            menuSource:props.menuSource,
            dbBuyerTin:""
        }
        this.individualIdTypeRef=React.createRef();
        this.idTypeRef=React.createRef();
    }

    getIndividualIdTypeData(){
        return this.individualIdTypeRef.current.getData();
    }

    getIdTypeData(){
        return this.idTypeRef.current.getData();
    }

    countryCodeChange(){
        const fartherForm = this.props.fartherForm.current;
        if(fartherForm && fartherForm.getFieldValue("buyerCountryCode")){
            const buyerCountryCode = fartherForm.getFieldValue("buyerCountryCode");
            if(CountryCode.MALAYSIA===buyerCountryCode){
                this.state.stateCodeDisabled=false;
            }else{
                this.state.stateCodeDisabled=true;
                fartherForm.setFieldsValue({buyerStateCode:StateCode.NOT_APPLICABLE});
            }
            this.setState({});
        }
    }

    changeTin(e) {
        const fartherForm = this.props.fartherForm.current;
        const supplierForm = this.props.supplierForm.current;
        //校验按钮权限
        let buttonId="";
        if(this.state.menuSource==='buyAddPermission'){
            buttonId="131140246060164106";
        }
        if(this.state.menuSource==='buyModifyPermission'){
            buttonId="131140246060164107";
        }
        postSync("aisino/transactionDataManagement/checkButtonAuthByTinAndId",{tin:e,menuId:buttonId}).then(res=> {
            if(res==false){
                aisinoInfoModal(invoiceLan.NoPermission);
                fartherForm.resetFields();
                supplierForm.resetFields();
                return;
            }else{
                // 选择tin时根据接口查询tin的其他信息
                postSync('aisino/myProfile/getUserInit',
                    {tin:e})
                    .then(v=>{
                        let buyerInfo={};
                        if(v){
                            buyerInfo.tin = e;
                            buyerInfo.buyerIdType = v.idType;
                            buyerInfo.buyerIdValue = v.idValue;
                            buyerInfo.buyerName = v.supplierName;
                            buyerInfo.buyerSst = v.supplierSst;
                            buyerInfo.buyerContactNum = v.supplierContactNum;
                            buyerInfo.buyerEmail = v.supplierEmail;
                            // buyerInfo.buyerCode = v.supplierName;
                            buyerInfo.buyerCountryCode = v.supplierCountryCode;
                            buyerInfo.buyerStateCode = v.supplierStateCode;
                            buyerInfo.buyerCityName = v.supplierCityName;
                            buyerInfo.buyerAddressLine0 = v.supplierAddressLine0;
                            buyerInfo.buyerAddressLine1 = v.supplierAddressLine1;
                            buyerInfo.buyerAddressLine2 = v.supplierAddressLine2;
                            buyerInfo.buyerPostalZone = v.supplierPostalZone;

                            fartherForm.setFieldsValue(buyerInfo);
                            supplierForm.resetFields();
                            const buyerCountryCode = buyerInfo.buyerCountryCode;
                            if(CountryCode.MALAYSIA===buyerCountryCode){
                                this.state.stateCodeDisabled=false;
                            }else{
                                this.state.stateCodeDisabled=true;
                            }
                            this.setState({});
                        }else{
                            //纳税人端-个人中心-taxpayer-info未维护纳税人信息
                            aisinoInfoModal(invoiceLan.informationMustBeMaintained);
                            // 清空 buyerTin 的值
                            fartherForm.setFieldsValue({ buyerTin: "" });
                            // 如果是 FormItemUrlSelect，还需要清空其选中状态
                            if (this.selectTinRef.current) {
                                this.selectTinRef.current.setValue(null);
                            }
                        }
                    });
            }
        })

    }

    searchBuyerClick(){
        this.props.searchBuyer();
    }

    idValueBlur(){
        const that= this;
        const fartherForm = that.props.fartherForm.current;
        const formData = fartherForm.getFieldsValue();
        let buyerIdType = formData.buyerIdType;
        let buyerIdValue = formData.buyerIdValue;
        if(buyerIdType&&buyerIdValue){
            postSync("aisino/transactionDataManagement/getTinByIdTypeAndIdValue",{idType:buyerIdType,idValue:buyerIdValue}).then(res=> {
                //2025-08-01 当接口返回不为空且不是异常时，才复制
                if(!isEmpty(res) && res!=="L4002"){
                    this.state.dbBuyerTin=res;
                    fartherForm.setFieldsValue({buyerTin:res});
                }
                else{
                    if(buyerIdType!==IndividualIdType.BRN){
                        const idTypeData =that.getIndividualIdTypeData();
                        idTypeData.map(item=>{
                            if(item.value===buyerIdType){
                                fartherForm.setFieldsValue({buyerTin:item.description});
                            }
                        })
                    }
                    else{
                        fartherForm.setFieldsValue({buyerTin:null});
                    }
                }
            });
        }
    }

    setDbBuyerTin(data){
        this.state.dbBuyerTin=data;
    }

    getTin(){
        const that= this;
        const fartherForm = this.props.fartherForm.current;
        let buyerIdType=fartherForm.getFieldValue("buyerIdType");
        let buyerIdValue=fartherForm.getFieldValue("buyerIdValue");
        postSync("aisino/searchTaxpayerTin/getTaxpayerTinByIdTypeAndIdValue",{idType:buyerIdType,idValue:buyerIdValue}).then(res=> {
            //2025-08-01 当接口返回不为空且不是异常时，才复制
            if(!isEmpty(res) && res!=="L4002"){
                this.state.dbBuyerTin=res;
                fartherForm.setFieldsValue({ buyerTin: res });
            }
            else{
                if(buyerIdType!==IndividualIdType.BRN){
                    const idTypeData =that.getIdTypeData();
                    idTypeData.map(item=>{
                        if(item.value===buyerIdType){
                            fartherForm.setFieldsValue({buyerTin:item.description});
                        }
                    })
                }
                else{
                    fartherForm.setFieldsValue({buyerTin:null});
                }
            }
        })
    }
    buyerTinBlur(){
        const that = this;
        const dbBuyerTin = that.state.dbBuyerTin;
        if(dbBuyerTin){
            const fartherForm = that.props.fartherForm.current;
            const buyerTin = fartherForm.getFieldValue("buyerTin");
            if(buyerTin!==dbBuyerTin){
                aisinoConfirmModal(invoiceLan.changeTin,"",function(){
                    that.state.dbBuyerTin="";
                },function(){
                    fartherForm.setFieldsValue({ buyerTin: dbBuyerTin });
                })
            }
        }
    }
    render() {
        const {disabled,h5Flag,selectTinFlag,showH5Flag,showAddressFlag} = this.props;
        let isBuyerCodeHidden = this.props.isBuyerCodeHidden;
        let buyerStateCodeDisabled = disabled || this.state.stateCodeDisabled;
        if( typeof isBuyerCodeHidden === "undefined"){
            isBuyerCodeHidden=true;
        }
        let hideAddrFlag = false;
        if(isEmpty(showAddressFlag)){
            hideAddrFlag = false;
        }
        else if(showAddressFlag){
            hideAddrFlag=true;
        }
        let idTypeEl=[];
        if(h5Flag){
            idTypeEl.push(<FormItemDictSelect ref={this.individualIdTypeRef} typecode={"individualIdType"} label={invoiceLan.buyerIdType.label} name={"buyerIdType"} disabled={disabled} rules={[{required: !disabled}]} onChange={(e)=>this.props.changeIdType(e)}/>)
        }else{
            if (selectTinFlag) {
                idTypeEl.push(<FormItemDictSelect ref={this.idTypeRef} typecode={"idType"} label={invoiceLan.buyerIdType.label} name={"buyerIdType"} disabled={disabled} rules={[{required: !disabled}]}/>)
            } else {
                idTypeEl.push(<FormItemDictSelect ref={this.idTypeRef} typecode={"idType"} label={invoiceLan.buyerIdType.label} name={"buyerIdType"} disabled={disabled} rules={[{required: !disabled}]} onChange={(e)=>this.props.changeIdType(e)}/>)
            }
        }
        if(disabled){
            idTypeEl.push(<FormItemInput  label={invoiceLan.buyerIdValue.label} name={"buyerIdValue"}  disabled={disabled} rules={[{required: !disabled},{max:20}]} />);
        }else if(h5Flag){
            idTypeEl.push(<FormItemSearch  className={"idValueScanner"} label={invoiceLan.buyerIdValue.label} name={"buyerIdValue"}  disabled={disabled}
                                           rules={[{required: !disabled},{max:20}]} enterButton={<ScanOutlined />} onBlur={()=>this.idValueBlur()} onSearch={()=>this.props.showScanner()}/>);
        }else{
            if(selectTinFlag){
                idTypeEl.push(<FormItemInput  label={invoiceLan.buyerIdValue.label} name={"buyerIdValue"}  disabled={disabled} rules={[{required: !disabled},{max:20}]} />);
            }else{
                idTypeEl.push(<FormItemSearch  label={invoiceLan.buyerIdValue.label} name={"buyerIdValue"} rules={[{required: !disabled},{max:20}]} enterButton={commonLan.selectButton.label} onSearch={()=>this.searchBuyerClick()} onBlur={()=>this.getTin()}/>);
            }
        }
        if (selectTinFlag) {
            idTypeEl.push(<FormItemUrlSelect ref={this.selectTinRef}  type={"post"}
                                             label={invoiceLan.buyerTin1.label} name={"buyerTin"}
                                             url={"/invoice/aisino/portalIndex/getSelectedTinMapList"}
                                             valueField={"tin"} textField={"tin"} maxLength={50}
                                             disabled={disabled} rules={[{required: !disabled}]}
                                             onChange={(e)=>{this.changeTin(e)}}/>)
        } else {
            idTypeEl.push(<FormItemInput  label={h5Flag?invoiceLan.h5BuyerTin.label:invoiceLan.buyerTin1.label} name={"buyerTin"}  placeholder={h5Flag?"e.g. C12345678901":""}
                                          disabled={disabled}  rules={[{required: !disabled},{max:50}]} onBlur={()=>this.buyerTinBlur()}/>);
        }
        return(
            <div>
                {
                    isEmpty(showH5Flag) || showH5Flag ?
                        formItemLayout(idTypeEl.concat(
                                [
                                    <FormItemInput  label={invoiceLan.buyerName1.label} name={"buyerName"}  disabled={disabled} rules={[{required: !disabled},{max:300}]} />,
                                    <FormItemInput  label={invoiceLan.buyerSst.label} name={"buyerSst"}  disabled={disabled} rules={[{max:35}]}/>,
                                    <FormItemInput  label={invoiceLan.buyerContactNum.label} name={"buyerContactNum"}  disabled={disabled} rules={[{required: !disabled},{max:20},
                                        ({getFieldValue}) => ({
                                            validator(rule, value) {
                                                if(value){
                                                    let res = checkContactNum(value);
                                                    if(!res){
                                                        return  Promise.reject(commonLan.contactNumIncorrect);
                                                    }
                                                    else{
                                                        return Promise.resolve();
                                                    }
                                                }
                                                return Promise.resolve();
                                            },
                                        })]} />,
                                    <FormItemInput  label={invoiceLan.buyerEmail.label} name={"buyerEmail"} disabled={disabled} rules={[{required:h5Flag},{max:320},{ type: 'email' }]}/>,
                                    <FormItemInput  label={invoiceLan.buyerCode.label} name={invoiceLan.buyerCode.name} hidden={isBuyerCodeHidden} disabled={disabled} rules={[{max:100}]}/>
                                ]
                            )) :
                        formItemLayout([
                            <FormItemDictSelect typecode={"countryCodes"} label={invoiceLan.buyerCountryCode.label} name={"buyerCountryCode"} disabled={disabled} rules={[{required: !disabled}]} onChange={()=>{this.countryCodeChange()}}/>,
                            <FormItemDictSelect typecode={"stateCodes"} label={invoiceLan.buyerStateCode.label} name={"buyerStateCode"} disabled={buyerStateCodeDisabled} rules={[{required: !buyerStateCodeDisabled}]}/>,
                            <FormItemInput  label={invoiceLan.buyerCityName.label} name={"buyerCityName"}  disabled={disabled}  rules={[{required: !disabled},{max:50}]} />,
                            <FormItemInput  label={invoiceLan.buyerAddressLine.label} name={"buyerAddressLine0"}  disabled={disabled} rules={[{required: !disabled},{max:150}]}/>,
                            <FormItemInput  label={invoiceLan.buyerAddressLine1.label} name={"buyerAddressLine1"}  disabled={disabled} rules={[{max:150}]}/>,
                            <FormItemInput  label={invoiceLan.buyerAddressLine2.label} name={"buyerAddressLine2"}  disabled={disabled} rules={[{max:150}]}/>,
                            <FormItemInput  label={invoiceLan.buyerPostalZone.label} name={"buyerPostalZone"}  disabled={disabled} rules={[{required:h5Flag},{max:50}]}/>
                        ])
                }
                {
                    isEmpty(showH5Flag) ?
                        <AisinoFieldset title={invoiceLan.transactionAddress} content={formItemLayout([
                            <FormItemDictSelect typecode={"countryCodes"} label={invoiceLan.buyerCountryCode.label} name={"buyerCountryCode"} disabled={disabled} rules={[{required: !disabled}]} onChange={()=>{this.countryCodeChange()}}/>,
                            <FormItemDictSelect typecode={"stateCodes"} label={invoiceLan.buyerStateCode.label} name={"buyerStateCode"} disabled={buyerStateCodeDisabled} rules={[{required: !buyerStateCodeDisabled}]}/>,
                            <FormItemInput  label={invoiceLan.buyerCityName.label} name={"buyerCityName"}  disabled={disabled}  rules={[{required: !disabled},{max:50}]} />,
                            <FormItemInput  label={invoiceLan.buyerAddressLine0.label} name={"buyerAddressLine0"}  disabled={disabled} rules={[{required: !disabled},{max:150}]}/>,
                            <FormItemInput  label={invoiceLan.buyerAddressLine1.label} name={"buyerAddressLine1"}  disabled={disabled} rules={[{max:150}]}/>,
                            <FormItemInput  label={invoiceLan.buyerAddressLine2.label} name={"buyerAddressLine2"}  disabled={disabled} rules={[{max:150}]}/>,
                            <FormItemInput  label={invoiceLan.buyerPostalZone.label} name={"buyerPostalZone"}  disabled={disabled} rules={[{required:h5Flag},{max:50}]}/>
                        ])}/> :<></>
                }
            </div>
        )
    }

}
export default NonIndividualBuyerInfo;
